export const visitorTracking = (siteId, apiUri) => {
  if (!siteId) {
    throw new Error('siteId wasn\'t passed as argument.');
  }
  if (!apiUri) {
    throw new Error('apiUri wasn\'t passed as argument');
  }
  const formData = new FormData();
  formData.append('site_id', siteId);
  formData.append('request_uri', window.location.href);
  formData.append('referer_uri', document.referrer);
  const settings = {
    method: 'POST',
    mode: 'no-cors',
    body: formData
  };
  fetch(apiUri, settings).catch(err => console.log('Request failed', err));
};